const miscGetters = {
  getRequestStats: (state) => state.requestStats,
  getAboutList: (state) => state.abouts,
  getAbout: (state) => state.about,
  getContactServices: (state) => state.contactServices,
  getContactService: (state) => state.contactService,
  getAddPoints: (state) => state.points
}

export { miscGetters }
